import { Form } from 'react-angle-dashboard-components'
import styled from 'styled-components'

export const SmallGrayHeading = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #6c757d;
`

export const Heading = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #212529;
`

export const GrayText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  /* or 133% */
  display: flex;
  align-items: center;

  /* Text/02. Muted */
  color: #6c757d;
`

export const GrayTextLg = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;

  /* or 133% */
  display: flex;
  align-items: center;

  /* Text/02. Muted */
  color: #6c757d;
`

export const InvalidFeedback = styled(Form.Control.Feedback).attrs(() => ({
  type: 'invalid'
}))`
  display: block;
`
